module.exports = __webpack_public_path__ + "static/sui-breadcrumb-sizes-b41c32147ad8bf3598dee8b2981f308a.png";